import { render, staticRenderFns } from "./ProjectBasics.vue?vue&type=template&id=39af6d8b&scoped=true&"
import script from "./ProjectBasics.vue?vue&type=script&lang=js&"
export * from "./ProjectBasics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39af6d8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VDatePicker,VMenu,VSelect,VSpacer,VTextField})
